<template>
    <b-form-input
            :id="tag"
            :name="tag"
            type="text"
            v-model="value"
            :state="null"
            :placeholder="placeholder"
            @change="onChange"
            @keyup.esc="onKeyEsc"
            @keyup.enter="onKeyEnter"
            @focus.native="onFocus"
            :disabled="disabled || committed || notApplicable"
            size="sm"
            v-bind:class="{itempropertyupdated: isUpdated && ! notApplicable, invalidinput: isInvalid}"
            :style="'min-width: ' + bestCellWidth(value, tag) + '; text-align: right;'">
    </b-form-input>
</template>

<script>
    import baseGridMixin from './BaseGridMixin.vue'
    import cellTypeMixin from './CellTypeMixin.vue'
    import inputCellMixin from './InputCellMixin.vue'
    export default {
        mixins: [baseGridMixin, cellTypeMixin, inputCellMixin],
        props: {
            tag: {
                type: String,
                required: true
            },
            validation: {
                type: Object
            },
            brandId: {
                type: Number|String,
                required: true
            },
            countryId: {
                type: String,
                required: true
            },
            route: {
                type: String,
                required: true
            },
            storedData: {
                type: String|Number,
                default: null
            },
            placeholder: String,
            disabled: {
                type: Boolean,
                default: false
            },
            committed: {
                type: Boolean,
                default: false
            },
            gridItemIndex: {
                type: Number,
                required: true
            }
        },
        methods: {
            onChange: function (event) {
                this.isInvalid = false;

                if (this.value !== "") {
                    if ([
                        'prices__price_incl_tax',
                        'prices__delivery_charges',
                        'prices__other_tax',
                        'local_specs__traction_control_price',
                        'local_specs__brakes_abs_price',
                    ].includes(this.tag.substring(0, this.tag.lastIndexOf('__')))) {
                        this.value = (Math.round(this.value * 100) / 100).toFixed(2);
                    }

                    if ([
                        'local_specs__engine_power_kw',
                        'local_specs__engine_power_hp',
                    ].includes(this.tag.substring(0, this.tag.lastIndexOf('__')))) {
                        this.value = (Math.round(this.value * 10) / 10).toFixed(1);
                    }

                    if ([
                        'core_specs__engine_capacity',
                        'core_specs__emission_co2',
                        'local_specs__engine_power_rpm',
                    ].includes(this.tag.substring(0, this.tag.lastIndexOf('__')))) {
                        this.value = (Math.round(this.value * 1) / 1).toFixed();
                    }
                }

                let cellStateUnchanged = this.determineCellState();

                this.postUpdate(this.value, cellStateUnchanged);
            },
        }
    }
</script>
